import React from 'react';
import type { HeaderProps } from '../../../../types.tsx';

export const DefaultHeaderRenderer = ({ columnId }: HeaderProps) => <div>{columnId}</div>;
